module.exports = __webpack_public_path__ + "img/GR057.420517a1.png";